import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-28 pb-12 px-4 bg-white" data-id="element-75">
      <div className="max-w-3xl mx-auto text-center" data-id="element-76">
        <p className="text-sm md:text-base font-bold text-gray-500 uppercase tracking-widest mb-3" data-id="element-77">
          Las etapas de tus hijos no vuelven.
        </p>

        <h2 className="text-xl md:text-2xl font-bold text-red-600 mb-4" data-id="element-78">
          Tus hijos están creciendo. Y cada día que pasa sin conectar de verdad…
          es un recuerdo que nunca se va a crear.
        </h2>

        <h1 className="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight" data-id="element-79">
          ❤️ PACK 100 CITAS
          <span className="block text-2xl md:text-3xl text-blue-600 mt-2" data-id="element-80">
            Megapack Completo Mamá • Papá • Hijos
          </span>
        </h1>

        <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-8 text-left md:text-center shadow-sm" data-id="element-81">
          <p className="text-lg md:text-xl font-bold text-gray-800 mb-2" data-id="element-82">
            Momentos reales. Conexión profunda. Recuerdos que tus hijos van a
            guardar para siempre.
          </p>
          <p className="text-gray-700 font-medium" data-id="element-83">
            Tiempo de calidad listo para usar. Sin pantallas. Sin planificar
            nada. Solo abrís, elegís y conectás.
          </p>
        </div>

        <CTAButton text="👉 QUIERO CREAR RECUERDOS CON MIS HIJOS" subtext="Descarga digital inmediata • Garantía de satisfacción de 7 días" data-id="element-84" />

        <button onClick={scrollToPricing} className="w-full max-w-sm mx-auto block cursor-pointer mt-8" data-id="element-85">
          <img src="https://cdn.magicpatterns.com/uploads/nJ6227LTvBcXZFid5u8iHs/MOCAP_100_CITAS.png" alt="Pack 100 Citas" width={384} height={384} loading="lazy" decoding="async" className="w-full h-auto" data-id="element-86" />
        </button>

        <p className="text-gray-500 italic text-sm mt-6" data-id="element-87">
          "Dentro de unos años vas a agradecer haber creado estos momentos."
        </p>
      </div>
    </section>;
}